"use strict";

// Connecting vendors (plugins)
import "./_vendor";

// Functions
import { mobileCheck, langHandler, accordion, burger } from "./functions/";

// Components
// import { formValidation } from "./components/";

window.addEventListener("DOMContentLoaded", () => {
  mobileCheck();
  burger();
});
